import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bedroom_type: null,
  price: null,
  desiredMoveIn: null,
  label: {},
  checked: false,
  module: null,
  shouldFetchSlots: true,
};

const paramSlices = createSlice({
  name: "params",
  initialState,
  reducers: {
    setBedRoomType: (state, action) => {
      state.bedroom_type = action.payload;
    },
    setPrice: (state, action) => {
      state.price = action.payload;
    },
    setDesiredMoveIn: (state, action) => {
      state.desiredMoveIn = action.payload;
    },
    setShowAllUnit: (state, action) => {
      state.show_all_units = action.payload;
    },
    setContactUsMethod: (state, action) => {
      state.contact_us_method = action.payload;
    },
    setLabelItems: (state, action) => {
      state.label = action.payload;
    },
    resetLabelItems: (state) => {
      state.label = {};
      state.shouldFetchSlots = true;
    },
    setCheckBox: (state, action) => {
      state.checked = action.payload;
    },
    setModuleName: (state, action) => {
      state.module = action.payload;
    },
    setShouldFetchSlots: (state, action) => {
      state.shouldFetchSlots = action.payload;
    },
  },
});

export const selectBedRoomType = (state) => state.params.bedroom_type;
export const selectPrice = (state) => state.params.price;
export const selectDesiredMoveIn = (state) => state.params.desiredMoveIn;
export const selectShowAllUnit = (state) => state.params.show_all_units;
export const selectContactUsMethod = (state) => state.params.contact_us_method;
export const selectLabelItems = (state) => state.params.label;
export const selectChecked = (state) => state.params.checked;
export const selectModuleName = (state) => state.params.module;
export const getShouldFetchSlots = (state) => state.params.shouldFetchSlots;
export const {
  setBedRoomType,
  setPrice,
  setDesiredMoveIn,
  setShowAllUnit,
  setContactUsMethod,
  setCheckBox,
  setLabelItems,
  resetLabelItems,
  setModuleName,
  setShouldFetchSlots,
} = paramSlices.actions;

export default paramSlices.reducer;
